import React from 'react';
import { Fields, Wrapper } from './styled';
import { useSelector } from 'react-redux';
import { selectAgentExecutionSelected } from 'store/Agents/selectors';
import { get } from 'lodash';
import ExecutionParams from 'Screens/Automation/Agents/components/AgentDetail/components/ExecutionParams';
import ExecutionDates from './components/ExecutionDates';
import NonBooleanField from 'Screens/Automation/Agents/components/AgentDetail/components/ToolParams/components/Content/components/NonBooleanField';
import BooleanField from 'Screens/Automation/Agents/components/AgentDetail/components/ExecutionParams/BooleanField';
import SelectedWorkspaces from './components/SelectedWorkspaces';

const Parameters = () => {
  const agentExecutionSelected = useSelector(selectAgentExecutionSelected);
  const data = get(agentExecutionSelected, '[0]', {});
  const parameters_data = get(data, 'parameters_data', {});
  const executor_data = get(parameters_data, 'executor_data.args', {});
  const booleanParams = Object.keys(executor_data).filter((param) => typeof executor_data[param] === 'boolean');
  const nonBooleanParams = Object.keys(executor_data).filter((param) => typeof executor_data[param] !== 'boolean' && param !== 'create_date' && param !== 'update_date');

  return (
    <Wrapper>
      <ExecutionParams currentTool={ parameters_data } disabled runStatusLog />
      <ExecutionDates currentTool={ data } />
      <Fields>
        { booleanParams.map((param) => <BooleanField disabled key={ param } defaultValue={ get(executor_data, param, false) } param={ param } parameters={ executor_data } />)}
        { nonBooleanParams.map((param) => <NonBooleanField disabled key={ param } defaultValue={ get(executor_data, param, '') } param={ param } parameters={ executor_data } />) }
      </Fields>
      <SelectedWorkspaces data={ parameters_data } />
    </Wrapper>
  );
};

export default Parameters;
